import {RootState} from '../../utils/types';

export const historyIndexSelector = (state:RootState)=>state.historyIndex
